module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_personal_data", [["div",{"class":"user-notitfications border-color-3-trans-20"},[["div",{"class":"global-title"},[["textNode",{"text":"Personal Data Processing"}]]],["div",{},[["import",{"name":"user_personal_data_rows"}],["div",{"class":"user-communication"},[["div",{"class":"global-title"},[["textNode",{"text":"Communication"}]]],["import",{"name":"user_communications_rows"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/user/personal-data.tpl
// module id = 1258
// module chunks = 4